import { Phone } from "lucide-react";
import Reveal from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const STEPS = [
    {
        n: "1",
        title: "Ci contatti",
        desc: "Telefonata o mail: ci racconti di cosa hai bisogno, senza nessun impegno.",
    },
    {
        n: "2",
        title: "Facciamo conoscenza",
        desc: "Un primo colloquio per capire il ritmo, le abitudini e i giorni giusti per te.",
    },
    {
        n: "3",
        title: "Iniziamo insieme",
        desc: "Costruiamo la tua routine: spese, visite, accompagnamento, passeggiate. Tu pensi alla giornata, al resto pensiamo noi.",
    },
];

export const HowItWorks = () => (
    <section id="come-funziona" className="py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <Reveal className="mb-14 lg:mb-20 max-w-2xl">
                <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-terracotta">
                    Come funziona
                </p>
                <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-ink">
                    Tre passi, <em className="italic text-terracotta">zero pensieri.</em>
                </h2>
            </Reveal>

            <div className="relative grid grid-cols-1 md:grid-cols-3 gap-6">
                <div
                    aria-hidden="true"
                    className="hidden md:block absolute top-14 left-[16%] right-[16%] border-t-2 border-dashed border-line"
                />
                {STEPS.map((s, i) => (
                    <Reveal key={s.n} delay={0.12 * i}>
                        <div
                            data-testid={`step-${i + 1}`}
                            className="group relative h-full rounded-[28px] border border-line bg-cream p-8 lg:p-10 transition-all duration-500 hover:bg-stonewarm hover:-translate-y-1.5 hover:shadow-lg hover:shadow-ink/5"
                        >
                            <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-terracotta text-cream font-serif text-2xl">
                                {s.n}
                            </span>
                            <h3 className="mt-7 font-serif text-2xl sm:text-3xl font-light text-ink">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-sm sm:text-base leading-relaxed text-mutedwarm">
                                {s.desc}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2} className="mt-14 flex justify-center">
                <button
                    data-testid="howitworks-cta-call"
                    onClick={() => scrollToId("contatti")}
                    className="group inline-flex items-center gap-3 rounded-full bg-ink px-8 py-4 text-base font-bold text-cream transition-all duration-300 hover:bg-terracotta hover:-translate-y-0.5 hover:shadow-xl hover:shadow-terracotta/25"
                >
                    <Phone className="h-5 w-5 transition-transform duration-300 group-hover:rotate-12" />
                    Il primo passo è una chiamata
                </button>
            </Reveal>
        </div>
    </section>
);

export default HowItWorks;
